import React from 'react'
import LegalPageComponent from '../component/legalPage';
import httpService from '../../../shared/services/http.services';
import {API_CONFIG}  from '../../../shared/constants/api';
import SiteLoader from '../../../shared/components/loader/siteLoader';

import '../component/legalStyle.scss'
class LegalPageContainer extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            content: null,
            isLoading: true
        }
    }

    componentDidMount(){
        this.getlegalPageContent();
    }

    getlegalPageContent = async () => {
        httpService.get(`${API_CONFIG.basePagePath}/${this.props.match.params.id}`)
        .then((content) => {
            this.setState({
                content: content,
                isLoading: false
            })
        })
        // If there's an error fetching subpage content, going back to /legal page
        .catch((err) => {
            console.error(`Did not find legal page with id [${this.props.match.params.id}]\nGoing back to /legal page\n`, err);
            this.props.history.replace("/legal");
        })
    }
    render () {
        return (
            <>
                { this.state.isLoading &&
                    <div className="loadingWrap" >
                        <SiteLoader />
                    </div>
                }
                {
                    !this.state.isLoading && this.state.content &&
                    <LegalPageComponent content={ this.state.content } />
                }
                
            </>
        )
    }
}

export default LegalPageContainer